import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductionDeviceComponent } from './production-device.component';

const routes: Routes = [
  {
    path: 'production-device',
    data: { name: 'Add Production Devices', isTab: false },
    component: ProductionDeviceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductionDevicePageRoutingModule {}
